module.exports = __webpack_public_path__ + "img/section_1-svg_1.d6967b08.svg";